import type { Dispatch, AnyAction } from 'redux';

import * as CreateMaterialGroupsAPI from 'ab-api/web/materialGroup/createBulk';
import * as FindAssignableToBillableWorkAPI from 'ab-api/web/materialGroup/findAssignableToBillableWork';
import * as FindMaterialsForCompanyAPI from 'ab-api/web/materialGroup/findForCompany';
import * as RemoveMaterialGroupAPI from 'ab-api/web/materialGroup/remove';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function findCompanyMaterialGroups() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindMaterialsForCompanyAPI.W_MaterialGroup_FindForCompany_VM>(FindMaterialsForCompanyAPI.URL());
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createMaterialGroups(group: CreateMaterialGroupsAPI.W_MaterialGroups_Create_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post<void>(CreateMaterialGroupsAPI.URL(), group);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function removeMaterialGroup(materialGroupId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.delete<void>(RemoveMaterialGroupAPI.URL(materialGroupId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAssignableToBillableWork() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindAssignableToBillableWorkAPI.W_MaterialGroup_FindAssignableToBillableWork_VM>(FindAssignableToBillableWorkAPI.URL());
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
